import { HttpClient} from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { REGISTRY_API_URL, REGISTRY_APPLICATION } from '../../global/tokens';


@Injectable({
  providedIn: 'root'
})
export class DataInsightService {

  constructor(
    private http: HttpClient,
    @Inject(REGISTRY_API_URL) private apiUrl: string,
    @Inject(REGISTRY_APPLICATION) public application: string,
  ) { }



  getDataInsightsChartsData(participantId?:any): Observable<any> {
    if(this.application === 'Admin'){
    return this.http.get<any>(`${this.apiUrl}/${participantId}/live_data_givebacks`)
    }else{
      return this.http.get<any>(`${this.apiUrl}/live_data_givebacks`)
    }
  }
}
